jQuery.fn.incrementInput = function (options) {
    const applyValueConstrains = function (e, value) {
        value = e.hasAttribute('min') ? Math.max(value, e.getAttribute('min')) : value
        value = e.hasAttribute('max') ? Math.min(e.getAttribute('max'), value) : value
        return value
    }

    $(this).each(function () {
        const e = this
        const container = $(`<div class="incremental-block">${this.outerHTML}<a><svg><title>Decrease</title><use xlink:href="#icon-minus"></use></svg></a><a><svg><title>Increase</title><use xlink:href="#icon-plus"></use></svg></div></a>`)
        $(e).replaceWith(container)
        container.find('a:first-of-type').on('click', function () {
            const input = $(this).siblings('input:not(:disabled)')
            input.val(applyValueConstrains(e, parseInt(input.val() || 0) - 1)).trigger('input').trigger('change')
            return false
        })
        container.find('a:nth-of-type(2)').on('click', function () {
            const input = $(this).siblings('input:not(:disabled)')
            input.val(parseInt(input.val() || 0) + 1).trigger('input').trigger('change')
            return false
        })
        container.find('input').on('input', function () {
            this.value = !!this.value && Math.abs(this.value) >= 0 // not empty and is not NaN
                ? applyValueConstrains(this, this.value)
                : null
        })
    })
}

export default input => {
    $(input).incrementInput()
}
